import { render, staticRenderFns } from "./templates.vue?vue&type=template&id=46910a2a&"
import script from "./templates.vue?vue&type=script&lang=js&"
export * from "./templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports